import React, { useState } from "react"
import { useLazyQuery } from "@apollo/client"
import { Form, DatePicker, Alert, Divider } from "antd"
import CheckReport from "./checkboxReport"
import type { DatePickerProps } from "antd"
import { reportProp } from "../../../types/reports"
import { Heading } from "../../../components/styled/Heading"
import Button from "../../../components/styled/Button.styled"
import Container from "../../../components/styled/Container.styled"

const Reports = ({
  title,
  label,
  showDateRange = true,
  ...props
}: reportProp) => {
  const mode = "REPORT"
  const limit = 100000000

  const [startDate, setStartDate] = useState<React.Key>()
  const [endDate, setEndDate] = useState<React.Key>()
  const [selected, setSelected] = useState<Array<Object>>([])
  const [alertMessage, setAlertMessage] = useState<JSX.Element>()

  const [sendReport] = useLazyQuery(props.query, {
    onCompleted(data) {
      setAlertMessage(() => {
        return (
          <Alert type="success" message={`Report generated successfully`} />
        )
      })
      resetState()

      setTimeout(() => {
        let url
        if (!!data.listClaimsWithPagination) {
          url = data.listClaimsWithPagination.url
        } else if (!!data.changeAddressReport) {
          url = data.changeAddressReport.url
        } else {
          url = data.enrolments.url
        }
        window.location.replace(url)
      }, 2000)

      setTimeout(() => {
        resetState()
      }, 6000)
    },
    onError(err) {
      setAlertMessage(() => {
        return <Alert type="warning" message={err.message}></Alert>
      })
      resetState()
    },
  })

  const resetState = () => {
    setTimeout(() => {
      setAlertMessage(<></>)
    }, 3000)
  }

  const onFinish = async () => {
    sendReport({
      variables: {
        fields: selected,
        startDate,
        endDate,
        mode,
        limit,
      },
    })
  }

  const startDateCapture: DatePickerProps["onChange"] = (date, dateString) => {
    setStartDate(dateString)
  }

  const endDateCapture: DatePickerProps["onChange"] = (date, dateString) => {
    setEndDate(dateString)
  }

  const getSelectedHandler = (data: Array<Object>) => {
    setSelected(data)
  }

  return (
    <Container>
      <Heading
        heading={title}
        description="Report will be produced and downloaded as an excel file"
      />

      <div className="row mb-3">
        <div className="col">{alertMessage}</div>
      </div>

      <Form name="report" onFinish={onFinish} layout="vertical">
        <div className="row px-0 py-4 border">
          <div className="col-12 px-3">
            <CheckReport
              checkBoxList={props.checkBoxList}
              selected={getSelectedHandler}
            />
          </div>

          {/* Date Range Selection */}
          {showDateRange && (
            <div className="col-12 bg-light mt-4 px-5">
              {!!label && (
                <div className="row pt-3">
                  <div className="col">
                    <strong>{label}</strong>
                  </div>
                </div>
              )}

              <div className="row mt-4">
                <div className="col-md-6 col-12">
                  <Form.Item label="Start Date">
                    <DatePicker
                      onChange={startDateCapture}
                      disabledDate={(d) => d.isAfter(endDate)}
                      className="w-100"
                    />
                  </Form.Item>
                </div>
                <div className="col-md-6 col-12">
                  <Form.Item label="End Date">
                    <DatePicker
                      onChange={endDateCapture}
                      disabledDate={(d) => d.isBefore(startDate)}
                      className="w-100"
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
          )}

          <Divider />

          <div className="row justify-content-center">
            <div className="col-6 col-md-4">
              <Button type="submit">Export Report</Button>
            </div>
          </div>
        </div>
      </Form>
    </Container>
  )
}

export default Reports
